import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { ButtonRow } from '@components/styles';
import { Button } from 'primereact/button';
import SectionPanel from '@components/framework/panels/SectionPanel.tsx';
import { IdEntityTypeEnum } from '@api/ringil-api.v2';
import { Form as FormApi, proxiedPropertiesOf } from '@hooks/useForm/useForm';
import { Form } from '@components/pages/admin/companies/adminCompanyDetailForm.ts';
import { PrefixInput } from '@components/pages/admin/companies/AdminCompanyDetailInputs.tsx';
import SvgNumber from '@icons/number.svg?react';

interface ComponentProps {
  form: FormApi<Form>;
  setEntityPrefix: (idEntityType: IdEntityTypeEnum, prefix: string) => void;
  onSave: () => void;
  saving: boolean;
}

const names = proxiedPropertiesOf<Form>();

const PrefixesSection: React.FC<ComponentProps> = ({ form, setEntityPrefix, onSave, saving }) => {
  const { tr } = useTranslationLgs();

  return (
    <SectionPanel
      icon={<SvgNumber className={'w-6 h-6'} />}
      iconColor={'var(--content-tertiary)'}
      heading={tr('adminCompanyDetail.sectionPrefixes', 'Prefixes')}
      dataTestId={'admin-company-section-prefixes'}>
        <div className={'flex flex-row flex-wrap gap-4'}>
          <PrefixInput
            label={tr('adminCompanyDetail.manualPrefix', 'Manual prefix')}
            value={form.values.prefixManualAppId}
            onChange={v => form.setFieldValue(names.prefixManualAppId, v)}
          />
          {form.values.entityPrefixes?.map(({ idEntityType, prefix }) => (
            <PrefixInput
              key={idEntityType}
              label={tr('adminCompanyDetail.entityPrefix.' + idEntityType, idEntityType)}
              value={prefix ?? ''}
              onChange={v => setEntityPrefix(idEntityType, v)}
            />
          ))}
        </div>
        <ButtonRow>
          <Button label={tr('generic.save', 'Save')} onClick={onSave} loading={saving} disabled={saving} />
        </ButtonRow>
    </SectionPanel>
  );
};

export default PrefixesSection;
